export default "__VITE_ASSET__BB9T7ZAM__"